const Cookies = require('js-cookie')
const LazyLoad = require('vanilla-lazyload')
const flickity = require('flickity')
import './Select2Dropdown.js'
import { parsePhoneNumber } from 'awesome-phonenumber'

export default class Common {
    constructor() {
        this.notificationSticky = $('.notification-sticky')
        this.notificationStickyButton = $('.notification-sticky button')
        this.notificationStickyTimeout = this.notificationSticky.data('timeout')
        this.customSelect = $('.select2_select')
        this.jumpTop = $('.herospace-category-backtotop a')
        this.phoneInput = document.querySelector('#l_phone')
        this.countdownTimer = $('#countdown-timer')
        this.countdownTimerTarget = this.countdownTimer.data('target')
        this.countdownTimerStarted = false
        this.carousel = document.querySelectorAll('.herospace')
        this.instance = null
    }

    /**
     * Lazyload
     */

    lazyLoad() {
        var lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy"
        })
    }

    /**
     *  Notification sticky
     */

    initNotificationSticky() {
        let stickyId = $('.notification-sticky').attr('id');
        let stickyCookie = Cookies.get('ns-' + stickyId);

        if (stickyCookie == 0 || stickyCookie == undefined) {
            $('#' + stickyId).addClass('notification-visible')
        }

        if (this.notificationStickyTimeout !== undefined) {
            let stickyTimeout = Number(this.notificationStickyTimeout*1000);

            setTimeout(() => {
                this.hideNotificationSticky(stickyId, false)
            }, stickyTimeout);
        }
    }

    /**
     * Handle notification sticky button click
     */

    handleNotificationStickyButtonClick(e) {
        e.preventDefault();
        let stickyId = this.notificationSticky.attr('id');

        this.hideNotificationSticky(stickyId, true);
    }

    /**
     * Save cookie and close notification
     */

    hideNotificationSticky(stickyId, button) {
        let stickyUrl = this.notificationStickyButton.data('target');

        Cookies.set('ns-'+stickyId, '1', { expires: 365, path: "/" });
        this.notificationSticky.removeClass('notification-visible')

        if (button && stickyUrl !== undefined) {
            window.location.href = stickyUrl
        }
    }

    /**
     * Phone Input Init
     */

    initPhoneInput() {
        if (this.phoneInput.value.trim().length) {
            validateInput()
        }

        this.phoneInput.addEventListener('blur', validateInput)
        this.phoneInput.addEventListener('change', formatInput)
        this.phoneInput.addEventListener('keyup', formatInput)

        function formatInput() {
            document.querySelector('#l_phone').parentElement.classList.remove('is-danger', 'is-invalid', 'is-valid')
            // remove all non-numeric characters except plus sign
            document.querySelector('#l_phone').value = document.querySelector('#l_phone').value.replace(/[^0-9+]/g, '')
        }

        function validateInput() {
            formatInput()
            const pn = parsePhoneNumber(document.querySelector('#l_phone').value)
            if (pn.valid) {
                document.querySelector('#l_phone').parentElement.classList.add('is-valid')
            } else {
                document.querySelector('#l_phone').parentElement.classList.add('is-danger')
                if (document.querySelector('#l_phone').value.length) {
                    document.querySelector('#l_phone').parentElement.classList.add('is-invalid')
                }
            }
        }
    }

    /**
     * Countdown timer
     */

    countdownToDate() {
        let endTime = new Date(this.countdownTimerTarget)
        endTime = (Date.parse(endTime) / 1000)

        let now = new Date()
        now = (Date.parse(now) / 1000)

        let timeLeft = endTime - now
        let countdownTimerOver = endTime <= now

        if (countdownTimerOver && this.countdownTimer.css('display') !== 'none') {
            if (this.countdownTimerStarted) {
                this.countdownTimer.slideUp(300)
            }
            return
        }

        let days = Math.floor(timeLeft / 86400)
        let hours = Math.floor((timeLeft - (days * 86400)) / 3600)
        let hoursExt = days >= 0 ? hours + (days * 24) : hours
        let minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60)
        let seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)))

        if (hoursExt < '10') { hoursExt = '0' + hoursExt }
        if (minutes < '10') { minutes = '0' + minutes }
        if (seconds < '10') { seconds = '0' + seconds }

        $('#hours').html(hoursExt)
        $('#minutes').html(minutes)
        $('#seconds').html(seconds)

        if (!countdownTimerOver && !this.countdownTimerStarted) {
            this.countdownTimerStarted = true
            this.countdownTimer.slideDown(300)
        }
    }

    /**
     * Load flickity instance
     */
    startSlider() {
        if (this.carousel) {
            for(var i = 0; i < this.carousel.length; i++) {
                this.instance = new flickity(this.carousel[i], {
                    accessibility: false,
                    pauseAutoPlayOnHover: true,
                    autoPlay: 10000,
                    draggable: this.carousel[i].querySelectorAll('.herospace__slide').length > 1,
                    wrapAround: true,
                    cellAlign: 'center',
                    cellSelector: '.herospace__slide',
                    prevNextButtons: this.carousel[i].querySelectorAll('.herospace__slide').length > 1,
                    pageDots: this.carousel[i].querySelectorAll('.herospace__slide').length > 1,
                    selectedAttraction: 0.2,
                    friction: 0.8
                })
            }
        }
    }

    /**
     * Initialize class
     */
    init() {
        this.lazyLoad()

        if (this.phoneInput) {
            this.initPhoneInput()
        }

        if (this.countdownTimer.length) {
            setInterval(() => this.countdownToDate(), 1000);
        }

        if (this.notificationSticky.length) {
            this.initNotificationSticky()

            this.notificationStickyButton.on('click', (e) => this.handleNotificationStickyButtonClick(e))
        }

        $.fn.select2.defaults.set('minimumResultsForSearch', '-1')
        $.fn.select2.defaults.set('dropdownPosition', 'below')
        this.customSelect.select2()

        if (this.jumpTop.length) {
            this.jumpTop.on('click', () => {
                $('html, body').animate({ scrollTop: 0 }, 1000)
            })
        }

        if (this.carousel) {
            this.startSlider()
        }
    }
}
